import { heroCover } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      {/* subtle warm wash */}
      <div className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-primary-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-52 -left-32 h-[420px] w-[420px] rounded-full bg-accent-200/40 blur-3xl" />

      <div className="relative mx-auto flex w-full max-w-7xl flex-col gap-10 px-4 py-10 md:px-6 md:py-16 lg:flex-row lg:items-center lg:gap-14">
        {/* left text column */}
        <div className="flex w-full flex-col gap-6 lg:max-w-[46%]">
          <div className="inline-flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-70" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-500" />
            </span>
            <span className="text-xs font-bold tracking-widest text-primary-700">吃瓜91 · 第一线速递站 已连播 386 天</span>
          </div>

          <h1 className="text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl md:leading-[1.1]">
            全网第一线的瓜，
            <br />
            <span className="text-primary-600">91 前排</span>按时间给你排好
          </h1>

          <p className="max-w-xl text-[15px] leading-relaxed text-foreground-700 md:text-base">
            刚出锅的料第一时间往上摆，硬瓜甜瓜都有，不用等别人转手再发。想比手速就从这进，
            前排看点一屏给够，首发最快的地方始终是你刷瓜的第一站。
          </p>

          <div className="flex flex-wrap items-center gap-2 text-xs">
            <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1.5 font-semibold text-accent-900">
              <i className="ri-flashlight-fill text-sm" />本轮首发 · <span className="num font-bold">09:41</span> 更新
            </span>
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1.5 font-semibold text-primary-800">
              <i className="ri-fire-fill text-sm" />热乎度 <span className="num font-bold">94</span>
            </span>
            <span className="inline-flex items-center gap-1 rounded-full bg-background-50 border border-background-200 px-3 py-1.5 font-semibold text-foreground-700">
              <i className="ri-number-1 text-sm" />前排余席 <span className="num font-bold text-primary-600">27</span>
            </span>
          </div>

          <div className="mt-1 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#feed"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-run-fill text-base" /> 前排开蹲
            </a>
            <a
              href="#rank"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-background-300 bg-background-50 px-6 py-3 text-sm font-bold text-foreground-900 transition hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-restart-line text-base" /> 刷新本轮首发
            </a>
            <span className="inline-flex items-center gap-1.5 text-xs text-foreground-700">
              <i className="ri-time-line" />每 <span className="num font-bold">30</span> 秒自动轮换 · 手速决定前排
            </span>
          </div>
        </div>

        {/* right cover column */}
        <div className="flex w-full flex-col gap-4 lg:max-w-[54%]">
          <div className="relative w-full overflow-hidden rounded-xl border border-background-200">
            <div className="relative aspect-[16/10] w-full md:aspect-[16/9]">
              <img
                src={heroCover}
                alt="吃瓜91第一线前排热乎瓜首屏封面"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent" />
              <div className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1.5 text-xs font-bold text-background-50">
                <i className="ri-fire-fill text-sm" /> HOT · 本轮首发
              </div>
              <div className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-foreground-950/55 px-2.5 py-1.5 text-xs font-semibold text-background-50 backdrop-blur-sm">
                <i className="ri-time-line" /> <span className="num">00:00</span> 抢拍窗口
              </div>
            </div>
            <div className="flex items-center justify-between gap-3 border-t border-background-200 bg-background-50 px-4 py-3">
              <p className="text-sm font-bold text-foreground-950">今晚头条瓜 · 现场连续三帧被抓到端倪</p>
              <a
                href="#feed"
                className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-xs font-bold text-background-50 transition hover:bg-foreground-800"
              >
                <i className="ri-play-fill text-sm" /> 看首发
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}